import { disbursementService } from "../services/disbursement.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { disbursementConstants, nameSpace, disbursementDropdownConstants, name_space } from "../constants/disbursement.constants";
import { reset } from "redux-form";

export const getdisbursements = (requestParams) => {
    return async (dispatch) => {
        dispatch(request(requestParams));
        try {
            const response = await disbursementService.getAllDisbursements(requestParams);
            
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get all disbursement", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: disbursementConstants[`GET_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: disbursementConstants[`GET_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementConstants[`GET_${nameSpace}_FAILURE`], error };
    }
};

export const getRafflesDropdown = () => {
    return async (dispatch) => {
        dispatch(request());
        try {
            const response = await disbursementService.getAllRaffles();
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            // dispatch(showAlert("danger", "Failed to get all disbursement", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: disbursementDropdownConstants[`GET_${name_space}_REQUEST`], request };
    }
    function success(response) {
        return { type: disbursementDropdownConstants[`GET_${name_space}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementDropdownConstants[`GET_${name_space}_FAILURE`], error };
    }
};

export const viewDisbursementAction = (id) => {
    return async (dispatch) => {
        dispatch(request(id));
        try {
            const response = await disbursementService.getDisbursementById(id);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get disbursement details", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: disbursementConstants[`VIEW_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: disbursementConstants[`VIEW_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementConstants[`VIEW_${nameSpace}_FAILURE`], error };
    }
};
export const getRecipients = (param) => {
    console.log({param})
    return async (dispatch) => {
        dispatch(request(param));
        try {
            const response = await disbursementService.getAllWinners(param);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get disbursement recipient(s) details", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: disbursementConstants[`WINNER_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: disbursementConstants[`WINNER_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementConstants[`WINNER_${nameSpace}_FAILURE`], error };
    }
};

export const postDisbursementAction = (values, history) => {
    return async (dispatch) => {
        dispatch(request(values));
        try {
            const response = await disbursementService.createDisbursement(values);
            dispatch(success(response));
            dispatch(reset("disbursement_form"));

            dispatch(showAlert("success", "Disbursement Initiated"));

            dispatch(getdisbursements({ pageNum: 1, pageSize: 10, searchWord: "" }));
            dispatch(resetPost());
            dispatch(resetView());
            history.push("/disbursement");
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to disburse", error ? error.message || error.description : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: disbursementConstants[`POST_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return { type: disbursementConstants[`POST_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementConstants[`POST_${nameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: disbursementConstants[`POST_${nameSpace}_RESET`] };
    }
    function resetView() {
        return { type: disbursementConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const disbursementAction = (id, action, comment, cb, requestParams) => {

    const values = { disbursementId: id, action: action, remark: comment};
    return async (dispatch) => {
        dispatch(request(values));
        try {
            const response = await disbursementService.disbursementAction(values);
            dispatch(success(response));
            const text = {
                1: "Approved",
                2: "Rejected",
                3: "Redrafted"
            }
            dispatch(showAlert("success", `Disbursement with id - ${id} has been ${text[action]} successfully.`));
            dispatch(getdisbursements({...requestParams}));
            dispatch(resetPost());
            dispatch(resetView());
            cb();
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Disbursement review failed.", error ? error.message || error.description : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: disbursementConstants[`PATCH_${nameSpace}_REQUEST`], request  };
    }
    function success(response) {
        return { type: disbursementConstants[`PATCH_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: disbursementConstants[`PATCH_${nameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: disbursementConstants[`PATCH_${nameSpace}_RESET`] };
    }
    function resetView() {
        return { type: disbursementConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const resetWinners = () => {
    return { type: disbursementConstants[`VIEW_${nameSpace}_RESET`] };
};

